import React from "react"
import { LinkProps } from "next/dist/client/link"
import Link from "next/link"

import { cn } from "@/lib/utils"

const TextLinkWithArrow: React.FC<
  Omit<React.AnchorHTMLAttributes<HTMLAnchorElement>, keyof LinkProps<any>> &
    LinkProps<any> & {
      children?: React.ReactNode | undefined
      spanClassName?: string
      arrowDirection?: "left" | "right"
    } & React.RefAttributes<HTMLAnchorElement>
> = ({ children, className, spanClassName, arrowDirection = "right", ...props }) => {
  return (
    <Link
      {...props}
      className={cn(
        "text-sm text-gray-400 hover:text-primary",
        {
          'after:pl-0.5 after:font-mono after:!no-underline after:content-["❯"]': arrowDirection == "right",
          'before:pr-0.5 before:font-mono !no-underline before:content-["❮"]': arrowDirection == "left",
        },
        className
      )}
    >
      <span className={cn("underline", spanClassName)}>{children}</span>
    </Link>
  )
}

export default TextLinkWithArrow
